/**
 * Shared lookups mapping collection-case priority/status codes to their
 * numeric ids. Kept in a neutral leaf module so both the data hook
 * (useCollectionCasesData) and the demo service can depend on them without
 * importing each other (avoids a hook <-> service circular dependency).
 */
export const priorityCodeToId: Record<string, number> = {
  High: 1,
  Medium: 2,
  Low: 3,
};

export const statusCodeToId: Record<string, number> = {
  Active: 1,
  'On Hold': 2,
  Closed: 3,
  Promised: 4,
  Escalated: 5,
};
